// src/components/CartBanner.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { ShoppingCart, X } from 'lucide-react';
import './CartBanner.css';
import { useLocation } from 'react-router-dom';

const CartBanner: React.FC = () => {
    const navigate = useNavigate();
    const { itemCount, loading } = useCart();
    const [visible, setVisible] = React.useState(true);

    const location = useLocation();

    // ✅ Lista de páginas onde o banner DEVE aparecer
    const allowedPages = ['/marketplace', '/marketplace/'];

    // ✅ Verificar se está em página de detalhes de produto
    const isProductDetailPage = /^\/marketplace\/[a-zA-Z0-9]+$/.test(location.pathname);

    // ✅ Só mostrar em marketplace ou detalhes de produto
    const shouldShowBanner = allowedPages.some(page => location.pathname.startsWith(page)) || isProductDetailPage;

    // ✅ Reabrir banner quando itemCount mudar
    React.useEffect(() => {
        if (itemCount > 0) {
            setVisible(true);
        }
    }, [itemCount]);

    // ❗ Agora sim: retornos condicionais
    if (!shouldShowBanner) return null;
    if (itemCount === 0 || !visible) return null;
    if (loading) return null;

    return (
        <div className="cart-banner">
            <div className="cart-banner-content">
                <div className="cart-banner-info">
                    <ShoppingCart size={20} />
                    <span>
                        <strong>{itemCount}</strong> {itemCount === 1 ? 'item' : 'itens'} no carrinho
                    </span>
                </div>

                <div className="cart-banner-actions">
                    <button
                        className="btn-finish-purchase"
                        onClick={() => navigate('/checkout')}
                    >
                        Finalizar Compra
                    </button>

                    <button
                        className="btn-close-banner"
                        onClick={() => setVisible(false)}
                        title="Fechar"
                    >
                        <X size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartBanner;